import IntakeHeader from "./IntakeHeader"

export default function IntakeSuccess() {
  return (
    <div className="min-h-screen bg-slate-50">
      <IntakeHeader />
      <div className="mx-auto flex max-w-md items-center px-4 py-10">
        <div className="w-full rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
          <h1 className="mb-2 text-xl font-bold text-slate-900">Thank you</h1>
          <p className="text-slate-600">
            Your responses were received. Our team will review your information and follow up as needed.
          </p>
        </div>
      </div>
    </div>
  )
}
